export default httpClient => ({
  // Dentro do seu serviço cartão

  save: async ({ nome, numero, cvv, mes_val, ano_val, tipo, clinica_id, pagarme_id, token, profissional_id, corretor_id }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const data = {
      clinica_id,
      pagarme_id,
      nome,
      numero,
      cvv,
      tipo,
      mes_val,
      ano_val,
    };
    if (profissional_id) {
      data.profissional_id = profissional_id;
    }
    if (corretor_id) {
      data.corretor_id = corretor_id;
    }
    const response = await httpClient.post('/cartao', data, { headers });
    return {
      data: response.data,
    };
  },

  update: async ({ nome, tipo, mes_val, ano_val, id, pagarme_id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.patch('/cartao/' + id, {
      id,
      pagarme_id,
      nome,
      mes_val,
      ano_val,
      tipo,
    }, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/contatos/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/contatos', { headers });
    return { data: response.data }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/cartao/' + id, { headers });
    return {
      data: response
    }
  },
});